<template>
    <div class="enterprise-upgrade">
        <div class="content-box first">
            <TitleTip>您所填写的信息将会提供给电子签进行企业认证校验、存证，用于后续的签署合同、授权合约等</TitleTip>
            <div class="user-info">您（{{ $store.state.userInfo.name }}，{{ $store.state.userInfo.userIdNum }}），将为您的企业进行认证并签署合同</div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我是法定代表人</h1>
                <p>仅需两步即可升级到企业账号</p>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    手机号验证
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(1)">升级并认证</el-button>
            </div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我不是法定代表人</h1>
                <p>以企业代理人的方式进行认证</p>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    对公账户及开户行信息
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    内有授权书模板，请下载
                    <b>并加盖公章</b>
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(2)">升级并认证</el-button>
            </div>
        </div>
        <div class="content-box row">
            <div class="name">
                <h1>我是个体工商户</h1>
            </div>
            <div class="content">
                <p>
                    <span class="enterprises-select"></span>
                    营业执照原件的高清图片
                </p>
                <p>
                    <span class="enterprises-select"></span>
                    个体工商户只能本人进行认证操作
                </p>
            </div>
            <div class="operation">
                <el-button type="primary" :loading="loading" @click="startUpgrade(1)">升级并认证</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {fddEnterpriseUpgrade, fddEnterpriseStatus} from '@/api/user';
export default {
    components: {},
    data() {
        return {
            loading: false,
            status: 0,
        };
    },
    mounted() {
        this.fddInfo();
    },
    methods: {
        // 修改等待
        async waitConfirm(status, url) {
            if (status == 2) return (window.location.href = this.$contractRouter('/manage/contract/enterprise/fdd/signContract', 'url'));
            const flag = await this.$fadadaConfirm('企业认证', '请确认是否完成了企业认证', status, url);
            if (flag == 'success') {
                this.$message.success('企业认证成功');
                await this.$store.dispatch('getUserInfo');
                return (window.location.href = this.$contractRouter('/manage/contract/enterprise/fdd/signContract', 'url'));
            }
            if (flag == 'refresh') return this.fddInfo();
        },
        async fddInfo() {
            this.successLoading = true;
            const response = await fddEnterpriseStatus();
            const {state, result, msg} = response.data;
            if (!state) return this.$message.error(msg || '');
            const {isVerify, verifyUrl} = result;
            this.waitConfirm(isVerify, verifyUrl);
        },
        async startUpgrade(upgradeAuthType) {
            this.loading = true;
            const response = await fddEnterpriseUpgrade(upgradeAuthType);
            const {state, msg, result} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '操作失败，请稍后尝试。');
            const flag = await this.$msgbox({
                title: '前往电子合同平台“法大大”',
                message: '即将前往电子合同平台“法大大”，在该平台，你将，完成实名认证。',
                confirmButtonText: '确认前往',
            });
            if (flag === 'cancel') return;
            window.open(result);
            this.fddInfo();
        },
    },
};
</script>
<style lang="scss" scoped>
.enterprise-upgrade {
    .user-info {
        padding: 20px 0px 0px;
        font-weight: 400;
        color: $--color-font-normal;
        line-height: 14px;
    }

    .row {
        display: flex;
        margin: 20px 0 0;
        border-radius: 6px;
        padding: 74px 40px;
        justify-content: space-between;
        align-items: center;

        p {
            color: $--color-font-text;
            line-height: 12px;
        }

        .name {
            width: 30%;

            h1 {
                font-weight: 400;
                color: $--color-font-normal;
                line-height: 24px;
                margin-bottom: 16px;
                font-size: 24px;
            }
        }

        .content {
            width: 40%;

            p {
                margin: 16px 0;

                .enterprises-select {
                    background: url('~@/assets/img/enterprises/enterprises-select.svg') no-repeat center;
                    width: 12px;
                    height: 12px;
                    float: left;
                    font-size: 12px;
                    margin-right: 6px;
                }

                b {
                    color: $--color-font-normal;
                }
            }
        }
    }
}
</style>
